/**
 * Browser API helpers exposed to Blazor via JSInterop, e.g.
 * await JSRuntime.InvokeAsync<int>("browserUtils.innerWidth");
 */

export const browserUtils = {
  /** For binary payloads such as a ZIP bundle. */
  downloadFileBase64(filename: string, base64: string, mimeType: string = 'application/octet-stream'): void {
    const binary = atob(base64);
    const bytes = new Uint8Array(binary.length);
    for (let i = 0; i < binary.length; i++) {
      bytes[i] = binary.charCodeAt(i);
    }
    const blob = new Blob([bytes], { type: mimeType });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    link.style.display = 'none';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  },

  // innerWidth/userAgent/scrollToId replace eval-based interop so the CSP needs no 'unsafe-eval'.
  innerWidth(): number {
    return window.innerWidth;
  },

  userAgent(): string {
    return navigator.userAgent;
  },

  scrollToId(id: string, block: ScrollLogicalPosition = 'start'): void {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth', block });
  }
};

if (typeof window !== 'undefined') {
  (window as any).browserUtils = browserUtils;
}
